import { Button } from "@corpuscomplete/web-ui/components/button";
import { PlannedMealCalendar } from "@corpuscomplete/core-ui/nutrition/planned-meal/calendar";
import { PageHeader } from "@corpuscomplete/web/components/layout";
import { ScopeBreadcrumb } from "@corpuscomplete/web/modules/common/components/scope-breadcrumb";
import { Scope } from "@corpuscomplete/core/common/scope";

export function PlannedMealsHeader({
  filters,
  focusedDate,
  onFiltersChange,
  onNavigate,
  onScopeChange,
  scope,
}: {
  filters: PlannedMealCalendar.Filters;
  focusedDate: Temporal.PlainDate;
  onFiltersChange: (filters: PlannedMealCalendar.Filters) => void;
  onNavigate: (date: Temporal.PlainDate) => void;
  onScopeChange: (scopeId: string) => void;
  scope: Scope.Info;
}) {
  return (
    <PageHeader>
      <div className="mr-auto min-w-0">
        <ScopeBreadcrumb
          crumbs={[{ label: "Planned Meals", current: true }]}
          scope={scope}
          scopeBehavior="switchable"
          onScopeChange={onScopeChange}
        />
      </div>
      <Button
        variant="outline"
        size="sm"
        onClick={() => onNavigate(focusedDate.subtract({ days: 7 }))}
      >
        Previous week
      </Button>
      <Button variant="outline" size="sm" onClick={() => onNavigate(Temporal.Now.plainDateISO())}>
        Today
      </Button>
      <Button variant="outline" size="sm" onClick={() => onNavigate(focusedDate.add({ days: 7 }))}>
        Next week
      </Button>
      <select
        className="h-6 rounded-md border bg-background px-2 text-xs"
        value={filters.statuses?.[0] ?? ""}
        onChange={(event) =>
          onFiltersChange({
            ...filters,
            statuses: event.target.value
              ? ([event.target.value] as PlannedMealCalendar.Filters["statuses"])
              : null,
          })
        }
      >
        <option value="">All statuses</option>
        <option value="draft">Draft</option>
        <option value="published">Published</option>
      </select>
    </PageHeader>
  );
}
